import { Typography } from '@material-ui/core';
import React, { CSSProperties, FC, ReactNode } from 'react';

interface HeadingProps {
  children: ReactNode;
  style?: CSSProperties;
}

const Heading: FC<HeadingProps> = ({ children, style }) => (
  <Typography variant="h2" style={{ paddingTop: '48px', ...style }}>
    {children}
  </Typography>
);

export default Heading;
